/* unplugin-vue-components disabled */import script from "./BasicPlanAuto.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasicPlanAuto.vue?vue&type=script&lang=ts&setup=true"

import "./BasicPlanAuto.vue?vue&type=style&index=0&id=2617a7bf&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2617a7bf"]])

export default __exports__